import { apiRegistry } from '../../../common/infra/apiRegistry'
import { favoritesMem } from '../mem/favoritesMem'

apiRegistry.registerPostApi('removeFavorite', async (req) => {
  delete favoritesMem[req.wordId]
  return { success: true }
})
